import { jsx as _jsx } from "react/jsx-runtime";
import Layout from "../GeneralColumnLayout/GeneralColumnLayout";
/**
 * Displays the content in columns with small, medium and large layout variants
 *
 * It is used to be placed inside a `<ContentBox />` or `<ContentBoxSection />`
 *
 * The layout is defined in a number-array with the format:
 * number[,number][,number][...], where the number represents the value for size
 * in fractions.
 *
 * Examples: [1,1] ├────┤├────┤
 *
 * [2,1] ├──────┤├──┤
 *
 * [2,1,3] ├──┤├┤├────┤
 */
export const ColumnLayout = (props) => {
    const { children, small = [1], medium = small, large = medium, center, ...restProps } = props;
    return (_jsx(Layout, { breakpoints: [500, 800], ...restProps, center: center, colGap: "xl", columnSizes: [small, medium, large], rowGap: "m", children: children }));
};
export default ColumnLayout;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ29sdW1uTGF5b3V0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvQ29sdW1uTGF5b3V0L0NvbHVtbkxheW91dC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUNBLE9BQU8sTUFBTSxNQUFNLDRDQUE0QyxDQUFDO0FBR2hFOzs7Ozs7Ozs7Ozs7OztHQWNHO0FBQ0gsTUFBTSxDQUFDLE1BQU0sWUFBWSxHQUEwQixDQUFDLEtBQUssRUFBRSxFQUFFO0lBQzNELE1BQU0sRUFDSixRQUFRLEVBQ1IsS0FBSyxHQUFHLENBQUMsQ0FBQyxDQUFDLEVBQ1gsTUFBTSxHQUFHLEtBQUssRUFDZCxLQUFLLEdBQUcsTUFBTSxFQUNkLE1BQU0sRUFDTixHQUFHLFNBQVMsRUFDYixHQUFHLEtBQUssQ0FBQztJQUVWLE9BQU8sQ0FDTCxLQUFDLE1BQU0sSUFDTCxXQUFXLEVBQUUsQ0FBQyxHQUFHLEVBQUUsR0FBRyxDQUFDLEtBQ25CLFNBQVMsRUFDYixNQUFNLEVBQUUsTUFBTSxFQUNkLE1BQU0sRUFBQyxJQUFJLEVBQ1gsV0FBVyxFQUFFLENBQUMsS0FBSyxFQUFFLE1BQU0sRUFBRSxLQUFLLENBQUMsRUFDbkMsTUFBTSxFQUFDLEdBQUcsWUFFVCxRQUFRLEdBQ0YsQ0FDVixDQUFDO0FBQ0osQ0FBQyxDQUFDO0FBRUYsZUFBZSxZQUFZLENBQUMifQ==